import { useEffect, useState } from "react";
import api from "../../api";
import { getPrerender } from "../../prerender";

// Ancore delle sezioni della home (usate da menu e footer).
export const SECTION_ANCHORS = { chisiamo: "chi-siamo", lavora: "lavora-con-noi", partners: "partners", contatti: "contatti" };
export const SECTION_LABELS = { chisiamo: "Chi siamo", lavora: "Lavora con noi", partners: "Partners", contatti: "Contatti" };
const DEFAULT_KEYS = ["chisiamo", "lavora", "partners", "contatti"];

export const visibleSectionKeys = (layout) =>
  (layout && layout.length ? layout : DEFAULT_KEYS.map((key) => ({ key, visible: true })))
    .filter((l) => l.visible && SECTION_ANCHORS[l.key]).map((l) => l.key);

let cache = null;

// Menu del sito pubblico (pagine + sezioni visibili della home), condiviso tra le pagine.
export function useSiteNav() {
  const [nav, setNav] = useState(() => {
    if (cache) return cache;
    const pre = getPrerender();
    return { pages: pre?.menu || [], layout: pre?.layout || null };
  });
  useEffect(() => {
    if (cache) return;
    let alive = true;
    api.get("/site-nav").then((r) => {
      cache = { pages: r.data.pages || [], layout: r.data.layout || null };
      if (alive) setNav(cache);
    }).catch(() => {});
    return () => { alive = false; };
  }, []);
  return nav;
}
